import { RouteObject } from "react-router-dom";

export const sendcloudContractRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Sendcloud contracts" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { SendcloudContractsPage } =
            await import("./sendcloud-contracts-page");
          return { Component: SendcloudContractsPage };
        },
      },
    ],
  },
];
